import axios from "axios";
import { API_END_POINT } from "../../../constants/api";

const authConfig = () => ({
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("usertoken")}`,
  },
});

export function addTax(taxData) {
  const companyId = localStorage.getItem("companyId");
  const body = JSON.stringify({ ...taxData, companyId });
  return axios.post(`${API_END_POINT}/company/setting/tax-rate/add`, body, authConfig());
}

export function getTaxes(companyId) {
  return axios.get(
    `${API_END_POINT}/company/setting/tax-rate/get/${companyId}`,
    authConfig()
  );
}

export function editTax(updatedData, taxRateId) {
  const body = JSON.stringify(updatedData);
  return axios.put(
    `${API_END_POINT}/company/setting/tax-rate/update/${taxRateId}`,
    body,
    authConfig()
  );
}

export function deleteTax(taxRateId) {
  const companyId = localStorage.getItem("companyId");
  return axios.delete(
    `${API_END_POINT}/company/setting/tax-rate/delete/${taxRateId}/${companyId}`,
    authConfig()
  );
}
